import Vue from 'vue';
import Vuex from 'vuex';

// import conversation from './modules/conversation.js'
import group from './modules/group';
import user from './modules/user';
import global from './modules/global';
import search from './modules/search';
import app from './modules/app';
import debounce from 'lodash/debounce';
import axios from '@/libs/api.request';
// import conversation from './modules/conversation'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    currentJob: {}
  },
  mutations: {
    updateCurrentJob(state, job) {
      state.currentJob = job;
    }
  },
  actions: {
    getJobInfo: debounce(function ({ commit }, data) {
      commit('updateCurrentJob', null);
      return axios
        .request({
          url: 'front/v1/chat',
          method: 'get',
          params: {
            withResume: 1,
            to: data
          }
        })
        .then(res => {
          commit('updateCurrentJob', res.data);
        });
    }, 100)
  },
  modules: {
    // conversation,
    group,
    user,
    global,
    search,
    app
  }
});
